export default __webpack_public_path__ + "static/media/doctor4.39981dbd.png";